export const ADMIN_USER_ACCESS_ANALYTICS_SOURCE = 'adminUserAccess';
export const SPACE_PERMS_REPORT_POLL_INTERVAL_MS = 500;
